<template>
  <div class="loginBody ">
<!--    <img class="logo" src="../pages/homePage/img/move.png" />-->

    <div class="loginBodyCenter">
      <div class="loginTitle">
        <span>万户安智慧用电管理平台</span>
      </div>
      <div class="loginR wow fadeInRight">
        <div class="loginInner">
          <div class="loginTitle2 wow fadeInLeft" data-wow-delay="0.8s">欢迎登录系统!</div>
          <div class="loginInput wow fadeInLeft" data-wow-delay="1.2s">
            <div class="icon"><img src="../assets/home/icon_login_user.png" alt=""></div>
            <el-input v-model="userName" autocomplete="new-password"   placeholder="请输入账号" style="color: #fff"></el-input>
            <div class="close" v-if="userName" @click="clearInfo('userName')">
              <img src="../assets/home/icon_login_delete.png" alt="">
            </div>
          </div>
          <div class="loginInput wow fadeInLeft" data-wow-delay="1.5s">
            <div class="icon"><img src="../assets/home/icon_login_password.png" alt=""></div>
            <el-input autocomplete="new-password"  v-model="userPassword" placeholder="密码" type="password">
            </el-input>
            <div class="close" v-if="userPassword" @click="clearInfo('userPassword')">
              <img src="../assets/home/icon_login_delete.png" alt="">
            </div>
          </div>
          <div class="remember">
            <el-checkbox
              class="checkbox"
              v-model="checked"
              label="记住密码"
              name="type"
            ></el-checkbox>
            <p @click="clickForgetPwd()">忘记密码</p>
          </div>
<!--          <div class="forget wow flipInX" data-wow-delay="1.8s">忘记密码?</div>-->
          <div @click="login" class="loginBut wow fadeInLeft" data-wow-delay="2.1s">
            <span>登录</span>
          </div>
        </div>
      </div>
      <div class="bom-title" >
        <p>苏州万户安物联网科技有限公司，地址：江苏省昆山市黄浦江中路2388号333室，联系方式：13812948665，13451627172</p>
<!--       <p @click="toout()"> Copyright &copy;  杭州善瑟科技有限公司 版权所有 浙ICP备2022006581号-1</p>-->
      </div>
    </div>
    <div class="juanbian" @click="opentc()">
      <div class="sanjiao">

      </div>
    </div>
    <div class="password-blank" v-show="status">
      <div class="powerTc" v-if="status == 1">
        <div class="title">
      <span style="float: left;padding-left: 35px;padding-top: 10px">
        忘记密码
      </span>
          <span>
        <i class="el-icon-error" style="padding-right:21px;padding-top:15px;float: right;cursor:pointer;" @click="status = 0"></i>
      </span>
        </div>
        <div class="main-con" >
          <el-form :model="phoneID" :rules="rule" ref="ruleForm">
            <el-form-item prop="id">
              <el-input
                class="getInput"
                v-model="phoneID.id"
                placeholder="手机号"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                class="button"
                @click="nextStep()"
                round
                type="primary"
              >
                下一步
              </el-button>
            </el-form-item>
          </el-form>
        </div>

      </div>
      <div class="powerTc" v-if="status == 2">
        <div class="title">
      <span style="float: left;padding-left: 35px;padding-top: 10px">
        输入验证码
      </span>
          <span>
        <i class="el-icon-error" style="padding-right:21px;padding-top:15px;float: right;cursor:pointer;" @click="status = 0"></i>
      </span>
        </div>
        <div class="main-con" >
          <div class="content" style="margin-top: 40px; text-align: center">
            <div class="send">已发送至 {{ phoneID.id }}</div>
            <auth-code @finish="getCode" :getErrColor="errColor"></auth-code>
            <div class="tip" style="text-align: left; width: 100%">
              <p :style="errColor ? 'color:#F56C6C' : 'display:none'">
                请输入正确验证码
              </p>
            </div>
            <div class="recode" style="margin-top: 40px" v-if="showCountDown">
              <span style="color: #2a62ff">{{ countDown }}秒</span> 后重新获取
            </div>
            <div
              class="recode"
              style="margin-top: 40px; color: #2a62ff; cursor: pointer"
              v-if="!showCountDown"
              @click="againCode()"
            >
              重新获取
            </div>
          </div>
        </div>

      </div>
      <div class="powerTc" v-if="status == 3">
        <div class="title">
      <span style="float: left;padding-left: 35px;padding-top: 10px">
        重置密码
      </span>
          <span>
        <i class="el-icon-error" style="padding-right:21px;padding-top:15px;float: right;cursor:pointer;" @click="status = 0"></i>
      </span>
        </div>
        <div class="main-con">
          <el-form :model="phoneID" :rules="rule" ref="ruleForm2">
            <el-form-item prop="password">
              <el-input
                class="getInput"
                v-model="phoneID.password"
                show-password
                placeholder="密码"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                class="button"
                @click="getNewPassword()"
                round
                type="primary"
              >
                确定
              </el-button>
            </el-form-item>
          </el-form>
        </div>

      </div>
    </div>
    <div class="power-blank" v-show="showtc">
    <div class="powerTc">
      <div class="title">
      <span style="float: left;padding-left: 35px;padding-top: 10px">
        请扫描下方二维码
      </span>
        <span>
        <i class="el-icon-error" style="padding-right:21px;padding-top:15px;float: right;cursor:pointer;" @click="closeTc"></i>
      </span>
      </div>
      <div class="img-blank">
        <div class="box">
          <div class="border-con">
            <div class="img" id="qrcode" ></div>
          </div>

<!--          <vue-qr-->
<!--            :text="imgUrl"-->
<!--            :size="240"-->
<!--          >-->
<!--          </vue-qr>-->
          <p>用户APP</p>
        </div>
        <div class="box">
<!--          <vue-qr-->
<!--            :text="imgUrl2"-->
<!--            :size="240"-->
<!--          >-->
<!--          </vue-qr>-->
          <div class="border-con">
            <div class="img" id="qrcode2" ></div>
          </div>

          <p>工具APP</p>
        </div>
      </div>
    </div>
    </div>

    <div class="zztc" v-show="showtc || status">

    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Axios from "@/utils/Axios";
import authCode from "./components/authCode";

import QRCode from 'qrcodejs2'
let checkPhone = (rule, value, callback) => {
  let reg = /^1[34578]\d{9}$/;
  if (!reg.test(value)) {
    callback(new Error("请输入正确的手机号码格式"));
  } else {
    callback();
  }
};
export default {
  data() {
    return {
      userName: '',
      userPassword: '',
      showtc:false,
      checked:true,
      errColor: false,
      passwordtc: false,
      timer: null,
      qrcode: null,
      countDown: 0,
      showCountDown: true,
      imgUrl:"https://www.baidu.com",
      imgUrl2:"https://www.baidu.com",
      status:0,
      phoneID: {
        id: "",
        password: "",
        oldPassword: "",
        userId: 0,
      },
      rule: {
        id: [
          {
            validator: checkPhone,
            type: "number",
            required: true,
            trigger: "blur",
          },
        ],
        password: [
          {
            min: 6,
            max: 16,
            required: true,
            trigger: "blur",
            message: "密码长度必须在6~16位！",
          },
        ],
      },
    }
  },
  components: {authCode},
  mounted() {
    new this.$wow.WOW().init()

    let that = this;
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 13) {
        if (that.$route.path == "/newlogin") {
          that.login();
        }
      }
    };
    this.checked = localStorage.getItem("checked") == "true" ? true : false;

    if (this.checked) {
      this.userName = localStorage.getItem("loginName");
      this.userPassword = localStorage.getItem("loginPassword");
    } else {
      this.userName = "";
      this.userPassword = "";
    }
  },
  methods: {
    getNewPassword() {
      this.$refs.ruleForm2.validate((val) => {
        if (val) {
          const para = {
            method: "post",
            url: "login/updatePwd",
            data: {
              newPwd: this.$md5(this.phoneID.password),
              oldPwd: this.phoneID.oldPassword,
              userId: this.phoneID.userId,
            },
          };
          Axios.ajax(para).then((res) => {
            this.$message.success("修改成功！");
            this.status = 0;
          });
        }
      });
    },
    againCode() {
      const param = {
        method: "post",
        url: "/login/validateUser",
        data: {
          phone: this.phoneID.id,
        },
      };
      Axios.ajax(param).then((res) => {
        this.getCuntDown();
        this.status = 2;
        this.showCountDown = true;
      });
    },
    getCuntDown() {
      if (!this.timer) {
        this.countDown = 60;
        this.showCountDown = true;
        this.timer = setInterval(() => {
          if (this.countDown > 0 && this.countDown <= 60) {
            this.countDown--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.showCountDown = false;
          }
        }, 1000);
      }
    },
    getCode(code) {
      const param = {
        method: "post",
        url: "/login/validateVerifyCode",
        data: {
          phone: this.phoneID.id,
          verifyCode: code,
        },
      };
      Axios.ajax(param)
        .then((res) => {
          this.phoneID.oldPassword = res.data.oldPwd;
          this.phoneID.userId = res.data.userId;
          this.status = 3;
        })
        .catch(() => {
          this.errColor = true;
        });
    },
    nextStep() {
      this.$refs.ruleForm.validate((va) => {
        if (va) {
          const param = {
            method: "post",
            url: "/login/validateUser",
            data: {
              phone: this.phoneID.id,
            },
          };
          Axios.ajax(param).then((res) => {
            if (res.resultCode == 0) {
              this.getCuntDown();
              this.status = 2;
              this.showCountDown = true;
            } else {
              this.$message.warning(res.resultMessage);
            }
          });
        } else {
          return false;
        }
      });
    },
    clickForgetPwd() {


      this.status = 1;
      this.phoneID.id = "";
      this.phoneID.oldPassword = "";
    },
    geturl(){
      let that = this;
      let param = {};
      param.method = "post";
      param.url = "/app/version/getLast";
      param.data = {
        "appType": "APP_USER",
      }

      Axios.ajax(param).then((res) => {
        // this.imgUrl=res.data.packageUrl
        // this.imgUrl=res.data.packageUrl
        this.qrcodeScan(res.data.packageUrl)
      })
    },
    getTOOL(){
      let that = this;
      let param = {};
      param.method = "post";
      param.url = "/app/version/getLast";
      param.data = {

        "appType": "APP_TOOL"
      }

      Axios.ajax(param).then((res) => {
        // this.imgUrl2=res.data.packageUrl
       this.qrcodeScan2(res.data.packageUrl)

      })
    },
    qrcodeScan (url) {//生成二维码

      let qrcode = new QRCode('qrcode', {
        width: 240,  // 二维码宽度
        height: 240, // 二维码高度
        correctLevel: 3,
        text: url
      })

    },
    qrcodeScan2 (url) {//生成二维码
      let qrcode = new QRCode('qrcode2', {
        width: 240,  // 二维码宽度
        height: 240, // 二维码高度
        correctLevel: 3,
        text: url
      })

    },
    opentc(){
      this.showtc=true
      this.geturl()
      this.getTOOL()
    },
    closeTc(){
      const codeHtml = document.getElementById("qrcode");
      const codeHtml2 = document.getElementById("qrcode2");
      codeHtml.innerHTML = "";
      codeHtml2.innerHTML = "";
      this.showtc=false
    },
    toout(){
      window.open("https://beian.miit.gov.cn/#/Integrated/index") ;
    },
    clearInfo(e) {
      this[e] = ''
    },
    login() {
      var that = this
      //缓存用户名密码token
      localStorage.setItem("loginName", this.userName);
      localStorage.setItem("loginPassword", this.userPassword);
      localStorage.setItem("checked", this.checked);
      let param = {};
      param.method = "post";
      param.url = "/login";
      param.data = {
        loginName: this.userName,
        passwd: this.$md5(this.userPassword),
      };
      Axios.ajax(param).then((res) => {
        if (res.resultCode == "0") {

          //按钮权限控制
          let menusList=[]
          for(let i=0;i<res.data.menus.length;i++){
            menusList.push(res.data.menus[i].menuCode)
          }
          Vue.prototype.menusList=menusList
          localStorage.setItem("menusList", JSON.stringify(menusList));
          localStorage.setItem("userName", res.data.userName);
          localStorage.setItem("userId", res.data.userId);
          localStorage.setItem("deptId", res.data.deptId);
          sessionStorage.setItem("token", res.data.token);
          sessionStorage.setItem("url", res.data.roleType);
          sessionStorage.removeItem("active"); //为了让登录进去时 导航栏活跃在首页
          ///切换的时候需要换回来
          // this.$router.push("/newhome");

          if(  menusList.indexOf('HOME_PAGE')!='-1'){
            if (res.data.roleType == 2) {
              this.$router.push("/singlehome");
            }
            else if (res.data.roleType == 1 || res.data.roleType == 0 || res.data.roleType == 3) {
              this.$router.push("/newhome");
            } else {
              this.$message.error("当前用户无角色!");
            }
          }else{
            // this.$router.push("/stationList");
            this.$router.push("/newhome");
          }

        } else {
          this.$message.error("账号密码错误!");
        }
      });
    },
  },
  filters: {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.loginBody {
  background: url("../assets/home/loginBg.png") center center no-repeat;
  width: 100%;
  position: fixed;
  height: 100%;
  position: fixed;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;

  .loginBodyCenter {
    width: calc(100% - 280px);
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: column;
    align-content: flex-start;
    z-index: 10;

    .loginR {
      background: url("../assets/home/loginCenterbg.png") no-repeat;
      background-size: 100% 100%;
      width: 791px;
      height: 757px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: column;
      align-content: flex-start;

      .titleImg {
        width: 242px;
        height: 26px;
        margin: 0 auto;
        margin-top: 57px;
        margin-bottom: 42px;
      }

      .loginInput {
        width: 470px;
        height: 80px;
        background-size: 100% 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: flex-start;
        position: relative;
        border-bottom: 1px solid rgba(7, 255, 253, 1);

        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: nowrap;
          flex-direction: row;
          align-content: flex-start;
          width: 40px;

          img {
            width: 14px;
          }
        }

        input {
          width: 100%;
          background: none;
          height: 57px;
          position: relative;
          border: none;
          color: #00CDFF;
          outline: none;
          font-size: 20px;
          font-family: PingFang;
          font-weight: bold;
        }

        .vrifyCode2 {
          width: calc(100% - 120px);
        }

        input::-webkit-input-placeholder {
          color: rgba(#07FFFD, 0.3);

        }

        input::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: rgba(#07FFFD, 0.3);

        }

        input:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: rgba(#07FFFD, 0.3);

        }

        input:-ms-input-placeholder {
          /* Internet Explorer 10-11 */

          color: rgba(#07FFFD, 0.3);
        }
      }

      .loginInner {
        width: 488px;
        margin-top: 150px;

        .loginTitle2 {
          font-size: 32px;
          font-family: PingFang;
          font-weight: 400;
          color: #34DCFC;
          margin-bottom: 50px;
        }
      }

      .loginBut {
        background: url("../assets/home/loginBut.png") no-repeat;
        width: 488px;
        margin-top: 20px;
        height: 72px;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: flex-start;
        font-size: 34px;
        font-family: PingFang;
        font-weight: 400;
        color: #001366;
        cursor: pointer;
        letter-spacing: 30px;
        text-indent: 30px;
        z-index:100;
      }
    }
  }
}
.logo{
 position: absolute;
  top: 60px;
  left: 100px;
  width: 280px;
  height: 94px;

}
.zztc{
  background-color:#fff;filter:Alpha(Opacity=60);opacity:0.6;
width: 100%;
  height: 100%;
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
}
.login__form{
  z-index: 99;
  position: absolute;
  left: 20px;
  top: 60px;
  background: #FFFFFF;

  &__context{
    width: 350px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .title{
      font-size: 28px;
      font-weight: normal;
      color: #252B3C;
      margin-bottom: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        margin-right: 24px;
      }
    }
    .getInput{
      .el-input__inner{
        width: 348px ;
        height: 54px ;
        border-radius: 10px ;
        border: 2px solid #E9E9E9;
        margin-top: 36px;
        font-size: 18px;
        letter-spacing: 2px;
        color: #7D879F;
        //font-family: PingFangSC-Regular, PingFang SC;

      }
      .el-input__suffix-inner{
        position: relative;
        top: 20px;
      }
    }
    .remember{
      width: 350px;
      margin-top: 18px;
      display: flex;
      justify-content: space-between;
      .checkbox{
        .el-checkbox__label{
          font-weight: 400;
          color: #7D879F;
          font-size: 18px;
        }
      }
      p{
        cursor: pointer;
        font-size: 18px;
        //font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3D82EA;
        line-height: 25px;
      }
    }
    .button{
      width: 348px;
      height: 62px;
      margin-top: 45px;
      background: #2A62FF;
      border: none;
      border-radius: 34px;
      font-size: 20px;
      letter-spacing: 2px;
      //font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 28px
    }
  }
}
.login-context{
  position: absolute;
  left: 230px;
  top: 159px;
  &__top{
    width: 231px;
    height: 54px;
    font-size: 20px;
    //font-family: OPPOSans-M, OPPOSans;
    font-weight: normal;
    border: 2px solid #2A62FF;
    color: #2A62FF;
    line-height: 54px;
    letter-spacing: 3px;
    text-align: center;
  }
  &__bottom{
    width: 486px;
    height: 112px;
    margin-top: 25px;
    p{
      font-size: 36px;
      font-family: OPPOSans-M, OPPOSans;
      font-weight: normal;
      color: #444C64;
      line-height: 47px;
      letter-spacing: 5px;
    }
  }
}
.login-footer{
  overflow: hidden;
  z-index: 1;
  position: absolute;
  bottom: 0px;
  left: 0px;
  .images{
    height: 67.4vh;
    width: 73vw;
  }
}
.juanbian{
  width: 90px;
  height: 90px;
  position: absolute;
  top: 0;
  right: 0;

  background-image: url("../assets/home/juanbian.png");
  background-size: 100% 100%;
  cursor: pointer;
}
.send{
  color: #fff;
}
.recode{
  color: #fff;
}
.remember{
  width: 450px;
  margin-top: 18px;
  display: flex;
  justify-content: space-between;
  .checkbox{
    .el-checkbox__label{
      font-weight: 400;
      color: #7D879F;
      font-size: 24px;
    }
  }
  p{
    cursor: pointer;
    font-size: 18px;
    //font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
    line-height: 25px;
  }
}
.img-blank{
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  .box{
    margin-top: 20px;
    margin-left: 40px;
    .img{
      width: 240px;
      height: 240px;
      margin: 0 20px;
      background: #D8D8D8;
    }
    p{
      margin-top: 27px;
      margin-bottom: 60px;
      text-align: center;
      font-size: 18px;
      //font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 25px;
      letter-spacing: 2px;
    }
  }
}
.power-blank{
  width: 800px;
  height: 450px;
  position: absolute;
  top: calc(50% - 225px);
  left: calc(50% - 400px);
  z-index: 2000;
  .powerTc{
    width: 100%;
    height: 100%;
    background-color: #0C213F;
    .title{
      height: 45px;
      width: 100%;
      background-color: rgba(61, 130, 234, 0.4);
      font-size: 16px;
      font-family: PingFang;
      color: #6CBCFD;
      line-height: 24px;
      letter-spacing: 2px;
    }
  }
}
.password-blank{
  width: 600px;
  height: 300px;
  z-index: 1000;
  position: absolute;
  top: calc(50% - 150px);
  left: calc(50% - 300px);

  .powerTc{
    width: 100%;
    height: 100%;
    background-color: #0C213F;
    .title{
      height: 45px;
      width: 100%;
      background-color: rgba(61, 130, 234, 0.4);
      font-size: 16px;
      font-family: PingFang;
      color: #6CBCFD;
      line-height: 24px;
      letter-spacing: 2px;
    }
    .main-con{
      width: 80%;
      margin: 20px auto;
    }
  }
}
.bom-title{
  width: 800px;
  text-align: center;
  cursor: pointer;
  height: 80px;

  font-size: 14px;

  position: absolute;
  bottom: 20px;
  left: calc(50% - 400px);
  color: #dddddd;
  p{
    margin-bottom: 16px;
  }
}
.rememberpwd {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;
  width: 381px;
}

.guangxian {
  width: 72px;
  height: 100%;
  position: absolute;
  right: 17%;
  z-index: 0;

  ::v-deep {
    .lottie {
      height: 100%;
    }

    .lottie > div {
      height: 120% !important;
      bottom: 0 !important;
    }
  }
}

.guangxian2 {
  right: 30%;
  z-index: 0;
}

.guangxian3 {
  right: 35%;
  z-index: 0;
}

.guangxian4 {
  right: 45%;
  z-index: 0;
}

.guangxian5 {
  left: 9%;
  z-index: 0;
}

.loginImg {
  width: 900px;
  height: 810px;
  //background: url("../assets/login/loginbg2.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 0%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;
}

.loginTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;
  margin-bottom: -100px;

  img {
    width: 1077px;
  }
  span {
    font-size: 30px;
    font-family: PingFang;
    font-weight: bold;
    color: #FFFFFF;
    height: 120px;
    font-size: 45px;
    background: linear-gradient(0deg, #0344FF 0%, #05DCF8 80.126953125%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

.forget {
  font-size: 18px;
  font-family: PingFang;
  font-weight: 400;
  color: #34DCFC;
  margin-top: 30px;
  margin-bottom: 55px;
}

.close {
  height: 17px;
  width: 17px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;
  position: absolute;
  right: 0;

  img {
    width: 17px;
  }
}
.border-con{
  padding: 20px;
  background: #fff;
}

</style>
<style lang="scss">
.loginBody{

.el-input__inner {
  height: 48px;
  background: rgba(255, 255, 255, 1);
  border: none;
  font-size: 16px;
  font-weight: 500;
  color: #CDF7FF;
  outline: none;
  padding-left: 10px;
  padding-right: 10px;
}
  .el-input__inner:hover{
    border: none;
  }
  //.el-input:hover{
  //  border: 1px solid rgba(#00A8FF, 0);
  //
  //}

.el-input__prefix, .el-input__suffix {
  height: 28px;
  display: none;
}

/* 下面设置右侧按钮居中 */
.el-input__suffix {
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;
}

.el-input__icon {
  line-height: 28px;
}
}
#app .remember .el-checkbox .el-checkbox__label{
  font-size: 18px;
  color: #fff;
}
#app .loginBody .el-input .el-input__inner{
  height: 48px;
  background-color: rgba(61, 130, 234, 0.4);
  color: #fff;
}
#app .loginBody .el-input__inner:-webkit-autofill {
  transition: background-color 5000s ease-in-out 0s;
}

</style>
